import heroImg from "../../assets/images/paladinhero.png";

export default function HeroSection() {
  return (
    <section className="relative w-full flex flex-col">
      {/* ── Hero Background Area ── */}
      <div
        className="relative w-full min-h-screen flex items-center"
        style={{
          backgroundImage: `url(${heroImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Gradient Overlay */}
        <div
          className="absolute inset-0"
          style={{
            background: "linear-gradient(to bottom, #012D6F, #000000)",
            opacity: 0.7,
          }}
        />

        {/* Hero Content — Left Aligned */}
        <div className="relative z-10 text-white-pure px-12 md:px-24 w-full max-w-[48%]">
          {/* Main Title */}
          <p className="font-cinzel text-base text-white-pure tracking-widest uppercase mb-2">
            Agency License No.: <span className="font-bold">6010043</span>
          </p>
          <h1 className="font-cinzel text-4xl md:text-6xl font-bold leading-[1.05] mb-1">
            Protect What Matters Most.
          </h1>

          {/* Italic Subtitle */}
          <h2 className="font-constantia text-4xl md:text-6xl italic leading-[1.05] mb-6">
            Confidence Backed by Expertise.
          </h2>

          {/* Description */}
          <p className="font-times text-base md:text-lg text-white-warm leading-[1.5] mb-10">
            Paladin combines deep industry knowledge with an unwavering commitment
            to your trust — delivering tailored insurance solutions for
            individuals and businesses ready to move forward.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4">
            <button className="bg-blue-dark text-white-pure font-times text-xs tracking-widest uppercase px-8 py-4 hover:bg-blue-primary transition-colors rounded-md">
              Request a Consultation
            </button>
            <button className="bg-transparent text-white-pure font-times text-xs tracking-widest uppercase px-8 py-4 border border-white-pure hover:bg-white-pure hover:text-black-deep transition-colors rounded-md">
              Explore Coverage
            </button>
          </div>
        </div>
      </div>

      {/* ── Stats Bar ── */}
      <div className="w-full" style={{ backgroundColor: "#012E72" }}>
        <div
          className="grid grid-cols-3"
          style={{ borderTop: "1px solid rgba(255,255,255,0.25)", borderBottom: "1px solid rgba(255,255,255,0.25)" }}
        >
          {[
            { value: "20+", label: "Years of Industry Expertise", numAlign: "text-left", nudge: "160px" },
            { value: "5,000+", label: "Clients Protected", numAlign: "text-center", nudge: "0px" },
            { value: "100%", label: "Commitment to Your Trust", numAlign: "text-right", nudge: "-160px" },
          ].map((stat, i) => (
            <div
              key={i}
              className="flex flex-col items-center justify-center py-10 px-10 text-white-pure"
              style={{ borderRight: i < 2 ? "1px solid rgba(255,255,255,0.25)" : "none" }}
            >
              <span
                className={`font-constantia text-3xl md:text-4xl font-bold mb-0.5 w-full ${stat.numAlign}`}
                style={{ transform: `translateX(${stat.nudge})` }}
              >
                {stat.value}
              </span>
              <span className="font-times text-xs md:text-sm text-white-warm tracking-wide text-center">
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* ── Trusted By Bar ── */}
      <div
        className="w-full bg-white-pure py-8"
        style={{ borderBottom: "1px solid rgba(1,46,114,0.2)" }}
      >
        <div className="flex items-center justify-center gap-10">
          <span
            className="font-constantia text-sm tracking-wide uppercase whitespace-nowrap"
            style={{ color: "#012E72", opacity: 0.6 }}
          >
            Trusted By
          </span>
          <span className="font-constantia text-sm" style={{ color: "#012E72", opacity: 0.35 }}>|</span>
          {["Small Businesses", "Healthcare Professionals", "Contractors", "Real Estate Firms", "Individual Clients"].map((label, i) => (
            <span
              key={i}
              className="font-constantia text-sm md:text-base font-bold tracking-wider uppercase whitespace-nowrap"
              style={{ color: "#012E72" }}
            >
              {label}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}